import { buscar } from "../../../Commons/Scripts/Utils/Buscar";

const RUTA_SERVICIO = "/ConfiguracionInicial/WebService/ConfiguracionInicialWebService.asmx";

const ENDPOINTS = Object.freeze({
  CONSULTAR_ESTADO: `${RUTA_SERVICIO}/ConsultarEstadoConfiguracionInicial`,
  OBTENER: `${RUTA_SERVICIO}/ObtenerConfiguracionInicial`,
  INICIAR: `${RUTA_SERVICIO}/IniciarConfiguracionInicial`,
  GUARDAR_RESPUESTA: `${RUTA_SERVICIO}/GuardarRespuestaConfiguracionInicial`,
  POSPONER_SESION: `${RUTA_SERVICIO}/PosponerConfiguracionInicialEnSesion`,
  GENERAR_PLAN: `${RUTA_SERVICIO}/GenerarPlanConfiguracionInicial`,
  COMPLETAR: `${RUTA_SERVICIO}/CompletarConfiguracionInicial`,
  APLICAR_Y_COMPLETAR: `${RUTA_SERVICIO}/AplicarYCompletarConfiguracionInicial`,
  OMITIR: `${RUTA_SERVICIO}/OmitirConfiguracionInicial`,
});

const parsearRespuesta = (respuesta) => {
  const contenido = respuesta && Object.prototype.hasOwnProperty.call(respuesta, "d")
    ? respuesta.d
    : respuesta;
  if (typeof contenido !== "string") return contenido;
  try {
    return JSON.parse(contenido);
  } catch (_error) {
    return contenido;
  }
};

const extraerDatosRespuesta = (datos) => {
  if (datos && datos.Exitoso === false) throw datos;
  if (datos && datos.exitoso === false) throw datos;
  if (datos && datos.Exito === false) throw datos;
  if (datos && datos.exito === false) throw datos;
  if (datos && Object.prototype.hasOwnProperty.call(datos, "Datos")) return datos.Datos;
  if (datos && Object.prototype.hasOwnProperty.call(datos, "datos")) return datos.datos;
  return datos;
};

const crearErrorHttp = (respuesta) => ({
  Mensaje: respuesta?.responseJSON?.Message || "No fue posible comunicarse con el servidor.",
  Detalle: "SolicitudConfiguracionInicial",
  Interno: true,
  Tipo: "Error",
});

const invocar = (url, cuerpo = {}, esMutacion = false) =>
  buscar(url, cuerpo, {
    encabezados: esMutacion ? { "X-Citrus-Configuracion-Inicial": "1" } : {},
    procesarRespuesta: (respuesta) => extraerDatosRespuesta(parsearRespuesta(respuesta)),
    procesarError: crearErrorHttp,
  });

export const consultarEstadoConfiguracionInicial = () =>
  invocar(ENDPOINTS.CONSULTAR_ESTADO);

export const obtenerConfiguracionInicial = () =>
  invocar(ENDPOINTS.OBTENER);

export const iniciarConfiguracionInicial = () =>
  invocar(ENDPOINTS.INICIAR, {}, true);

export const guardarRespuestaConfiguracionInicial = (solicitud) =>
  invocar(ENDPOINTS.GUARDAR_RESPUESTA, { solicitud }, true);

export const posponerConfiguracionInicialEnSesion = () =>
  invocar(ENDPOINTS.POSPONER_SESION, {}, true);

export const generarPlanConfiguracionInicial = (solicitud) =>
  invocar(ENDPOINTS.GENERAR_PLAN, { solicitud }, true);

export const completarConfiguracionInicial = (solicitud) =>
  invocar(ENDPOINTS.COMPLETAR, { solicitud }, true);

export const aplicarYCompletarConfiguracionInicial = (solicitud) =>
  invocar(ENDPOINTS.APLICAR_Y_COMPLETAR, { solicitud }, true);

export const omitirConfiguracionInicial = (solicitud) =>
  invocar(ENDPOINTS.OMITIR, { solicitud }, true);

export { ENDPOINTS as CONFIGURACION_INICIAL_ENDPOINTS };
